module.exports = __webpack_public_path__ + "img/palmTree.aab4858f.svg";